import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select, TextField } from "ui";
import { MenuItem } from "@mui/material";
import DinteroModel from "./types/DinteroModel";
import FormRef from "../types/FormRef";

type DinteroFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: DinteroModel) => void;
};

const DinteroForm = forwardRef<FormRef, DinteroFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    account_id: {},
                    client_id: {},
                    client_secret: {},
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Account ID">
                                    <TextField
                                        fullWidth
                                        id="account_id"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Client ID">
                                    <TextField
                                        fullWidth
                                        id="client_id"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Client Secret">
                                    <TextField
                                        fullWidth
                                        id="client_secret"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default DinteroForm;
